import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig, ServiceHelper } from '../config';

@Injectable()
export class SquareService {
 
  constructor(
    public http: HttpClient,
    private serviceHelper: ServiceHelper,
    private appConfig: AppConfig,
  ) { }

 /**
  * Gets Square settings
  * @returns settings 
  */
 getSettings(): Observable<any> {
    let me = this;
    var headers = this.serviceHelper.GetHeaders();

    return this.http.get(this.appConfig.getConfig('apiUrl') + '/square/settings', { withCredentials: true, headers: headers });
  }
}